import { scrollToHash } from "./Nav";

const LINKS = [
    { label: "Home", hash: "#home" },
    { label: "How It Works", hash: "#how-it-works" },
    { label: "Gallery", hash: "#examples" },
];

export const Footer = () => (
    <footer className="border-t border-slate-800 bg-slate-950 py-14 text-slate-400">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
                <div>
                    <img
                        src="/assets/scan2ad-logo.webp"
                        alt="Scan2Ad"
                        data-testid="footer-logo"
                        className="h-16 w-auto"
                    />
                    <p className="mt-4 flex items-center gap-2.5 text-sm font-medium text-slate-500">
                        Powered by
                        <img
                            src="/assets/dolphin-logo.png"
                            alt="Dolphin Digital OOH Media"
                            data-testid="footer-dolphin-logo"
                            className="h-10 w-auto"
                        />
                    </p>
                </div>

                <nav className="flex flex-wrap gap-x-8 gap-y-3">
                    {LINKS.map((link) => (
                        <a
                            key={link.hash}
                            href={link.hash}
                            onClick={scrollToHash(link.hash)}
                            className="text-sm font-semibold text-slate-400 transition-colors duration-200 hover:text-white"
                        >
                            {link.label}
                        </a>
                    ))}
                    <a
                        href="https://manage.scan2ad.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-semibold text-teal-400 transition-colors duration-200 hover:text-teal-300"
                    >
                        Create an Ad
                    </a>
                </nav>
            </div>

            <div className="mt-12 border-t border-slate-800/80 pt-8">
                <p data-testid="footer-copyright" className="text-sm text-slate-500">
                    © 2026 Dolphin Digital OOH Media. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
);
